// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './mytools/directive'
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router/index'
import {install} from './mytools/mytools'
import filters from './mytools/filters'
import Vant from 'vant';
import store from './store/store'
Vue.config.productionTip = false;

import Viewer from 'v-viewer'
import 'lib-flexible/flexible'
import 'vant/lib/index.css';
import 'viewerjs/dist/viewer.css'
import './assets/css/style.less'
import './assets/js/filters'
import 'vant/lib/icon/local.css';
import 'babel-polyfill'
// import VConsole from 'vconsole/dist/vconsole.min.js' //import vconsole
// let vConsole = new VConsole() // 初始化
Vue.use(Viewer);
Vue.use(Vant);
install(Vue);
Viewer.setDefaults({
    Options: { "inline": true, "button": true, "navbar": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});
Vue.config.ignoredElements = ['wx-open-launch-app'];
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  store: store,
  template: '<App/>',
  components: { App }
})




// WEBPACK FOOTER //
// ./src/main.js